'use strict';
var userAgent = require('../internals/environment-user-agent');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/environment-is-ios-pebble.js
// module id = 671
// module chunks = 0